import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Popconfirm, Pagination, message, Spin, Select, Input, Button, Modal, Tabs, DatePicker } from 'antd';
import $ from '../../../common/AjaxRequest';
import Fetch from '../../../common/Fetch';
import API_URL from '../../../common/url';
import RegisterRequest from './RegisterRequest';
import ApproveCancelApply from './ApproveCancelApply';
import BaBatchTransfer from './BaBatchTransfer';
import ApproveBaBatchTransfer from './ApproveBaBatchTransfer';
import ExpectHour from './ExpectHour';
import ConterctRelateSite from './ConterctRelateSite';
import AuditJDE from './AuditJDE';
import moment from 'moment';
import '../style/notice.less';
import { saveParams, saveSearchParams } from '../../../actions/noticeActions';
import { saveParams as saveProjectParams } from '../../../actions/investigationActions';
import { saveParams as saveResumeParams } from '../../../actions/PersonalActions';

import fp from '../../../utils/fp';
import SearchRetrieve from '../../common/SearchRetrieve.new';

const { Option } = Select;
const TabPane = Tabs.TabPane;

const parseQueryConditions = (queryConditions,isSplitValue, splitType = ',') => {
    const fields = (queryConditions || '').split(splitType);
    const params = {};
    for (let i = 0, len = fields.length; i < len; i++) {
        const keyValue = fields[i].split('=');
        if(isSplitValue){
            params[keyValue[0]] =( keyValue[1]+'').replace(/_/g,',');
        }else{
            params[keyValue[0]] = keyValue[1];
        }
    }
    return params;
};
const clearCenter = (setSession) => {
    setSession.invId = "";
    setSession.invName = "";
    setSession.investigationSiteCode = "";
    setSession.investigationSiteName = "";
    setSession.siteId = "";
};
const setProject = (setSession, item, isCenter) => {
    setSession.invId = item.investigationId;
    setSession.invName = item.investigationName;
    setSession.investigationSiteCode = "";
    setSession.investigationSiteName = isCenter ? "中心汇总" : '';
    setSession.siteId = '';
};
const setCenter = (setSession, item) => {
    setSession.invId = item.investigationId;
    setSession.invName = item.investigationName;
    setSession.investigationSiteCode = item.investigationSiteCode;
    setSession.investigationSiteName = item.investigationSiteName;
    setSession.siteId = item.investigationSiteId;
};

class Filter extends Component {
    state = {
        searchParams: {},
        planFteAdjustment: 0,
        contractSiteRelate:0,
        infoConfirm: 0,
    }

    componentDidMount() {
        const { searchParams } = this.props;
        const { noticeType } = searchParams || {};
        this.setState({
            searchParams: { ...searchParams },
            planFteAdjustment: noticeType=='PLAN_FTE_ADJUSTMENT' ? 1 : 0,
            contractSiteRelate: noticeType=='CONTRACT_RELATE_SITE' ? 1 : 0,
            infoConfirm: noticeType=='SSU_HOSPITAL_INFO_CONFIRM' ? 1 : 0,
        }, () => {
            this.search();
        });
        this.props.saveSearchParams({ noticeType: undefined, noticeValue: undefined, activeKey: undefined });
    }

    search = () => {
        const { searchParams, planFteAdjustment, contractSiteRelate, infoConfirm } = this.state;
        this.props.search({ ...searchParams, planFteAdjustment, contractSiteRelate, infoConfirm });
    }

    handleSelectChange = (value, field) => {
        const { searchParams } = this.state;
        searchParams.noticeType = value.noticeType;
        searchParams.noticeValue = value.noticeValue;
        this.setState({ searchParams, planFteAdjustment: 0, contractSiteRelate: 0, infoConfirm: 0 });
    }

    handleInputChange = (e, field) => {
        const { searchParams } = this.state;
        searchParams[field] = e.target.value;
        this.setState({ searchParams });
    }

    handleDateChange = (date, dateString) => {
        const { searchParams } = this.state;
        searchParams.noticeDate = dateString;
        this.setState({ searchParams });
    }

    handleChange = (value, key) => {
        const { searchParams } = this.state;
        const { value: id, text: name } = value;
        searchParams[`${key}Id`] = id;
        searchParams[`${key}Name`] = name;
        this.setState({ searchParams })
    };

    render() {
        const { searchParams: { noticeValue, investigationName } } = this.state;
        return (
            <div style={{ width: "80%", margin: "0 auto", marginBottom: "15px" }}>
                <span style={{ marginRight: "10px" }}>消息类型</span>
                <SearchRetrieve
                    keyword='noticeValue'
                    allowClear={true}
                    style={{ width: 160 }}
                    params={{ limit: 20 , configureType: 'NOTICE' }}
                    placeholder="输入名称检索"
                    value={noticeValue}
                    url={API_URL.notice.queryNoticeConfigureList}
                    config={{ id: 'noticeConfigureId', name: 'noticeValue' }}
                    onChange={option => this.handleSelectChange(option, 'noticeType')}
                />
                <span style={{ marginLeft: "10px", marginRight: "10px" }}>项目简称</span>
                <SearchRetrieve
                    keyword='investigationName'
                    allowClear={true}
                    style={{ width: 160 }}
                    params={{ limit: 20 }}
                    placeholder="输入名称检索"
                    value={investigationName}
                    url={API_URL.investigation.queryInvestigationByName}
                    config={{ id: 'investigationId', name: 'investigationName' }}
                    onChange={option => this.handleChange(option, 'investigation')}
                />
                <span style={{ marginLeft: "10px", marginRight: "10px" }}>通知时间</span>
                <DatePicker disabledDate={current => { return current && current.valueOf() > Date.now()}} onChange={(date, dateString) => this.handleDateChange(date, dateString)} />
                <Button style={{ marginLeft: 10 }} type="primary" onClick={this.search}>搜索</Button>
            </div>
        );
    }
}

class Notice extends Component {
    state = {
        pagination: {
            pageSize: 10,
            current: 1,
        },
        loading: false,
        data: [],
        ids: [],
        auditJdeParams: {
            showAuditJDE: false,
        },
        expectHourParams: {
            visible: false,
        },
        loading: false,
        stageList: [],
        searchParams: {},
        centerRelateParams:{
            visible: false,
        }
    }

    loadData = () => {
        const { searchParams, pagination, pagination: { pageSize, current } } = this.state;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.home.queryTodayNoticeAll,
            data: {
                limit: pageSize,
                offset: current,
                ...searchParams
            },
            dataType: 'json',
            doneResult: res => {
                const { datas = [], totalCount } = res;
                pagination.total = totalCount;
                this.setState({
                    pagination,
                    data: datas,
                    loading: false,
                });
            }
        };
        $.sendRequest(options);
    }
    //搜索
    search = (params) => {
        const { pagination } = this.state;
        pagination.current = 1;
        this.setState({
            pagination,
            searchParams: {...params}
        }, () => {
            this.loadData();
        });
    }

    operateAll = (type) => {
        const { data } = this.state;
        let params = {};
        data.map((item, index) => {
            params[`ids[${index}]`] = item.noticeId;
        });

        const url = type == 'delete' ? API_URL.home.emptyAllNoticeByUserId : API_URL.home.confirmNoticeRead;
        
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url,
            data: {  ...params },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.setState({ loading: false }, () => {
                    this.loadData();
                });
                window.dispatchEvent(new CustomEvent('smo:notice-count-refresh'));
            }
        };
        $.sendRequest(options);
    }

    hideAuditJDE = () => {
        const { auditJdeParams } = this.state;
        auditJdeParams.showAuditJDE = false;
        this.setState({ auditJdeParams });
    }

    hideExpectHour = () => {
        const { expectHourParams } = this.state;
        expectHourParams.visible = false;
        this.setState({ expectHourParams });
    }
    hideCenterctRelateSite = () => {
        const { centerRelateParams } = this.state;
        centerRelateParams.visible = false;
        this.setState({ centerRelateParams });
    }

    handlePages = (page, pageSize) => {
        this.setState((prevState) => ({
            pagination: {
                ...prevState.pagination,
                current: page,
            }
        }), () => {
            this.loadData();
        });
    }

    // JDE主项目号审批通知
    handleJdeMainCode = (setSession) => {
        const { auditJdeParams } = this.state;
        auditJdeParams.noticeId = setSession.noticeId;
        const options = {
            method: 'POST',
            url: API_URL.investigation.queryJdeExamineNotice,
            data: {
                noticeId: setSession.noticeId
            },
            dataType: 'json',
            doneResult: res => {
                auditJdeParams.title1 = res.title1;
                auditJdeParams.title2 = res.title2;
                auditJdeParams.showAuditJDE = true;
                this.setState({ auditJdeParams });
            }
        };
        $.sendRequest(options);
    }

    handleExpectHour = (setSession, params) => {
        const { planFteAdjustmentById } = params;
        const { expectHourParams } = this.state;
        const options = {
            method: 'POST',
            url: API_URL.notice.queryPlanFteAdjustmentById,
            data: { planFteAdjustmentById },
            dataType: 'json',
            doneResult: res => {
                const { planFteAdjustmentNotice } = res;
                const { status } = planFteAdjustmentNotice;
                if (status === 'NEW' || status === 'DELAY') {
                    expectHourParams.visible = true;
                    expectHourParams.setSession = setSession;
                    expectHourParams.planFteAdjustmentById = planFteAdjustmentById;
                    this.setState({ expectHourParams });
                } else if (status === 'DOWN') {
                    message.error('该条提醒已经处理');
                }
            },
        };
        $.sendRequest(options);
    }

    // 新人带教老师登记通知
    handleRegisterTeacher = (noticeId, params) => {
        const { userId, isDirectSupervisor, ...rest } = params;
        Modal.confirm({
            title: '是否现在去登记此新人的带教老师？',
            okText: '是，现在去登记带教老师',
            cancelText: '否，此人员无需登记带教老师',
            width: 490,
            onOk: () => {
                const { saveParams } = this.props;
                let href = '/#/teaching/management';
                if (isDirectSupervisor == 1) {
                    rest.activeKey = 'promotion';
                    href = '/#/user/userInfo';
                }
                saveParams(rest);
                location.href = href;
            },
            onCancel: () => {
                Fetch.post(API_URL.notice.setNotNeedTeacher, {
                    userId
                }).then(res => {
                    message.success(res.success);
                }).catch(err => {
                    console.error(err);
                });
            },
        });
        this.confirmNoticeReadByOne(noticeId);
    }
    // 中心关联合同通知
    handlContractRelateModal = (noticeId, params,centerRelateShow) => {
        const {readStatus,handlerStatus} = params;
        if(!handlerStatus){
            const { centerRelateParams } = this.state;
            centerRelateParams.visible = centerRelateShow;
            centerRelateParams.noticeId = noticeId;
            centerRelateParams.readStatus = readStatus;
            this.setState({ centerRelateParams });
        }else{
            message.error('该条提醒已经处理');
        }
    }

    //访视周期计划审批
    handleVisitApproval = (params) =>{
        const { path ,handlerStatus, target, } = params;
        if(handlerStatus){
            message.error('该条提醒已经处理');
            return
        }
        if (path !== "javascript:void(0)" || path) {
            if( target == 'inInv') {
                // 保存页面查询参数至store
                const { saveParams } = this.props;
                if (Object.keys(params).length !== 0) {
                    saveParams({...params});
                }
            }
            location.href = path;
        }
    }

    autoRegisterRequest = (setSession, params) => {
        this.setState({ loading: true });
        Fetch.post(API_URL.contract.selectContractForAddRemittance, {
            investigationId: params.investigationId,
            type: 'application',
            isModify: 0,
        }).then(res => {
            const { data } = res;
            this.setState({ loading: false }, () => {
                this.setSession(setSession);
                this.props.saveParams({ ...params, autoAdd: true });
                location.href = '/#/contractManagement/requestRecord';
            });
        }).catch(error => {
            console.error(error);
            this.setState({ loading: false });
        });
    }

    handleRequestRegister = (setSession, params) => {
        const { webCondition } = params;
        if (webCondition === 'NOT_POP') {
            this.autoRegisterRequest(setSession, params);
        } else if (webCondition !== 'NOT_JUMP') {
            this.requestRef.show(setSession, params);
        }
    }
    handleResumeNotice =(params) =>{
        const myuserId = sessionStorage.userId;
        const {userId,typeName,workStatus} = params;
        if(myuserId == userId){
            this.props.saveResumeParams({
                ...params,
                isChinese:typeName=='CHINESE'?true:false,
                canEdit:workStatus?workStatus=='WORKING':true,
                showModal :true,
            })
            location.href = './#/personal/curriculumVitae'
        }else{
            this.props.saveResumeParams({
                ...params,isChinese:typeName=='CHINESE'?true:false,
                canEdit:workStatus?workStatus=='WORKING':true,
                showModal :true,
            })
            location.href = './#/user/curriculumVitae'
        }
    }
    
    handleNationalVerificationNotice = (params) =>{
        this.props.saveParams({...params});
        location.href = './#/qualityManagement/nationalverification';
    }

    //办事流程
    showWorkFlow = (record) => {
        const { hospitalId = '', hospitalName = '', relateId } = record;
        sessionStorage.hospitalId = hospitalId;
        sessionStorage.hospitalName = hospitalName;
        sessionStorage.relateId = relateId;
        location.href = `./#/hospital/workFlow`;
    }

    setSession = (setSession) => {
        if (Object.keys(setSession).length !== 0) {
            for (let [k, v] of Object.entries(setSession)) {   //解构赋值
                sessionStorage[k] = v;
            }
        }
    }
    //点击消息回调
    clickNotice = (path, setSession, noticeId, index, params) => {
        switch(path) {
            case 'NATION_VERIFY_ADD':{
                this.handleNationalVerificationNotice(params);
                this.confirmNoticeReadByOne(noticeId);
                break;
            }
            case "VISIT_APPROVAL":{
                this.handleVisitApproval(params);
                this.setSession(setSession);
                this.confirmNoticeReadByOne(noticeId);
                break;
            }
            case 'VITAE_APPROVAL':{
                this.handleResumeNotice(params);
                this.confirmNoticeReadByOne(noticeId);
                break;
            }
            //中心关联
            case 'CONTRACT_RELATE_SITE': {
                this.handlContractRelateModal(noticeId, params,true,setSession);
                this.setSession(setSession);
                break;
            }
            case 'JDEEXAMINEMODAL': {
                this.handleJdeMainCode(setSession);
                this.confirmNoticeReadByOne(noticeId);
                break;
            }
            case 'PLAN_FTE_ADJUSTMENT': {
                this.handleExpectHour(setSession, params);
                this.confirmNoticeReadByOne(noticeId);
                break;
            }
            case 'USER_TEACHER_REMIND': {
                this.handleRegisterTeacher(noticeId, params);
                break;
            }
            case 'REMITTANCE_REGISTER': {
                this.confirmNoticeReadByOne(noticeId);
                this.handleRequestRegister(setSession, params);
                break;
            }
            case 'AUTHORITY':{
                this.confirmNoticeReadByOne(noticeId);
                this.props.saveProjectParams({ feedBack: true, searchParams: params, current: params.activeKey });
                this.setSession(setSession);
                location.href = '/#/invList';
                break;
            }
            case 'DISEASE_CHANGE':
            case 'INVESTIGATION_STOP':
            case 'LINE_OF_BUSINESS_CHANGE':
            case 'INVESTIGATION_INFO_COMPLETED': {
                this.confirmNoticeReadByOne(noticeId);

                this.props.saveProjectParams({ feedBack: true, searchParams: params });
                
                this.setSession(setSession);
                location.href = '/#/invList';
                break;
            }
            case 'CASH_REQ_NODE_REACH':
            case 'MILESTONE_REACH_NOTICE':
            case 'MILESTONE_DATE_REACH_NOTICE':
            case 'CONTRACT_CASH_REQ': {
                this.confirmNoticeReadByOne(noticeId);

                if (params.webCondition === 'NOT_JUMP') {
                    break;
                }
                if (path === 'MILESTONE_REACH_NOTICE' && setSession.curRole === 'PML') {
                    break;
                }
                if (setSession.curRole === 'PM') {
                    this.props.saveParams(params);
                    this.setSession(setSession);
                    location.href = '/#/projectContract/requestRecord';
                } else {
                    this.props.saveParams(params);
                    this.setSession(setSession);
                    location.href = '/#/contractManagement/requestRecord';
                }
                break;
            }
            case "NOTICE_CANCEL": {
                this.confirmNoticeReadByOne(noticeId);

                const { relateId, webCondition } = params;
                if (webCondition !== 'NOT_POP') {
                    this.approveRef.show(relateId);
                }
                break;
            }
            case "BA_CHANGE": {
                this.confirmNoticeReadByOne(noticeId);

                this.props.saveParams(params);

                this.setSession(setSession);
                location.href = '/#/contractManagement/responseCustomer';
                break;
            }
            case 'CONTRACT_MODIFY_NOTICE': {
                this.confirmNoticeReadByOne(noticeId);

                this.props.saveParams(params);

                this.setSession(setSession);
                if (setSession.invId > 0) {
                    location.href = '/#/projectContract/contractInfoChange';
                } else {
                    location.href = '/#/contractManagement/contractInfoChange';
                }
                break;
            }
            case 'COMPETING_COMPANY': {
                this.confirmNoticeReadByOne(noticeId);

                this.props.saveParams(params);

                this.setSession(setSession);
                location.href = '/#/competeCompany/performance';
                break;
            }
            case "BA_HAND_OVER_Receiver":
            case "BA_HAND_OVER_Over": {
                this.confirmNoticeReadByOne(noticeId);

                const { relateId, webCondition } = params;
                if (webCondition !== 'NOT_POP') {
                    this.baTransferRef.show(path === 'BA_HAND_OVER_Receiver', relateId);
                }
                break;
            }
            case "BA_HAND_OVER_Over_1":
            case "BA_HAND_OVER_BAL": {
                this.confirmNoticeReadByOne(noticeId);

                const { relateId, webCondition } = params;
                if (webCondition !== 'NOT_POP') {
                    this.approveBaTransferRef.show(path === 'BA_HAND_OVER_BAL', relateId);
                }
                break;
            }
            case 'INVESTIGATION_FINISH_PERCENT_CONFIRM':
                this.confirmNoticeReadByOne(noticeId);
                this.props.saveParams({...params});
                location.href = '/#/home/myFocus';
                break;
            case 'SSU_HOSPITAL_INFO_CONFIRM':
                this.showWorkFlow(params);
                this.confirmNoticeReadByOne(noticeId);
            break;
            default: {
                this.confirmNoticeReadByOne(noticeId);

                // 保存页面查询参数至store
                const { saveParams } = this.props;
                if (Object.keys(params).length !== 0) {
                    saveParams({...params});
                }
                
                this.setSession(setSession);
                if (path !== "javascript:void(0)" || path) {
                    location.href = path;
                }
            }
        }
    }
    //确认已读
    confirmNoticeReadByOne = (noticeId) => {
        const options = {
            method: 'POST',
            url: API_URL.home.confirmNoticeReadByOne,
            data: { noticeId },
            dataType: 'json',
            doneResult: () => {
                this.loadData();
                window.dispatchEvent(new CustomEvent('smo:notice-count-refresh'));
            }
        };
        $.sendRequest(options);
    }

    getNoticList = () => {
        const { data } = this.state;
        const list = [];
        if (data.length > 0) {
            data.map((item, index) => {
                let type;
                let path;
                let params = {};
                const setSession = {};
                switch (item.noticeType) {
                    case 'HOSPITAL_DIRECTOR_CHANGE':
                        type = '医院负责人变更通知';
                        path = '/#/hospital/detail';
                        params = parseQueryConditions(item.queryConditions);
                        break;
                    case 'HOSPITAL_DEPARTMENT_DIRECTOR_CHANGE':
                        type = '科室负责人变更通知';
                        path = '/#/hospital/departmentDetail';
                        params = parseQueryConditions(item.queryConditions);
                        break;
                    case 'HOSPITAL_DEPART_CHARGE_CHANGE':
                        type = '科室leader变更通知';
                        path = '/#/hospital/departmentDetail';
                        params = parseQueryConditions(item.queryConditions);
                        break;
                    case 'REQUEST_PAY_USER_CHANGE':
                        type = '科室请款负责人变更通知';
                        path = '/#/hospital/departmentDetail';
                        params = parseQueryConditions(item.queryConditions);
                        break;
                    case 'PM_VIRTUAL_LINE_CHANGE':
                        type = 'PM虚拟汇报线变更通知';
                        path = '/#/user/DashedReport';
                        params = parseQueryConditions(item.queryConditions);
                        break;
                    case 'SET_USER_HOSPITAL_COURTYARD_AREA':
                        type = '医院院区配置通知';
                        path = '/#/user/userInfo';
                        params = parseQueryConditions(item.queryConditions);
                        break;
                    case 'RESPONSIBLE_HOSPITAL_NOTICE':
                        type = '负责医院科室通知';
                        path = '/#/user/userInfo';
                        params = parseQueryConditions(item.queryConditions);
                        //跳转到 人员主要/次要负责医院科室 页签
                        params.activeKey = 'chargeHospital';
                        break;
                    case 'INVESTIGATION_REQUIREMENT':
                        type = '需求通知';
                        if (item.roleCode) {
                            const roleCode = item.roleCode;
                            if (roleCode == 'CRCM' || roleCode == 'CRCC' || roleCode == 'CRC') {
                                path = item.roleCode === 'CRC' ? 'javascript:void(0)' : `/#/user/require/${item.relateId}`;
                            } else {
                                path = `/#/member/require/${item.relateId}`;
                                setCenter(setSession, item);
                                setSession.curRole = item.roleCode;
                            }
                        }
                        break;
                    case 'HANDOVER_REQUIREMENT':
                        type = '交接通知'
                        if (item.roleCode) {
                            const roleCode = item.roleCode;
                            params = parseQueryConditions(item.queryConditions);
                            if( params.target &&  params.target == 'invPmHandover'){
                                if(item.webCondition == 'NOT_JUMP'){
                                    path = "javascript:void(0)"
                                }else{
                                    this.props.saveParams({...params, type:'PM'});
                                    path = `/#/execute/transfer/`;
                                    setProject(setSession, item, true);
                                    setSession.curRole = item.roleCode;
                                }
                            }else if(params.target &&  params.target == 'pmHandover'){
                                path = `/#/user/pmTransfer/`;
                                clearCenter(setSession);
                            }else if (roleCode == 'CRCM' || roleCode == 'CRCC') {
                                path = `/#/user/transfer/${item.relateId}`;
                                clearCenter(setSession);
                            } else {
                                if(item.webCondition == 'NOT_JUMP'){
                                    path = "javascript:void(0)"
                                }else{
                                    path = `/#/execute/transfer/${item.relateId}`;
                                    setCenter(setSession, item);
                                    setSession.curRole = item.roleCode;
                                }
                            }
                        }
                        break;
                    case 'PM_HANDOVER_REQUIREMENT':
                        type = 'PM交接通知';
                        params = parseQueryConditions(item.queryConditions);
                        if( params.target &&  params.target == 'invPmHandover'){
                            if(item.webCondition == 'NOT_JUMP'){
                                path = "javascript:void(0)"
                            }else{
                                this.props.saveParams({...params, type:'PM'});
                                path = `/#/execute/transfer/`;
                                setProject(setSession, item, true);
                                setSession.curRole = item.roleCode;
                            }
                        }else {
                            path = `/#/user/pmTransfer/`;
                            clearCenter(setSession);
                        }
                        break;
                    case 'VISIT':
                        type = '访视通知'
                        path = `/#/execute/crf/Type_Visit/${item.relateId}`;
                        setCenter(setSession, item);
                        break;
                    case 'EVENT':
                        type = '事件通知';
                        path = 'javascript:void(0)';
                        break;
                    case 'AUTHORITY':
                        type = '授权通知';
                        params = parseQueryConditions(item.queryConditions);
                        path = (params.target == 'OUT_INV_END_INV_LIST' || params.target == 'OUT_INV_INV_LIST') ?  `AUTHORITY` : `/#/contractManagement/responseCustomer`;
                        params.investigationName = item.investigationName;
                        params.activeKey = params.target == 'OUT_INV_END_INV_LIST' ? '0' : '1'
                        clearCenter(setSession);
                        break;
                    case 'MANHOUR':
                        type = '工时通知';
                        path = item.relateId ? `/#/manHour/write/${item.relateId}/${item.noticeInfo.substring(0, 10)}` : 'javascript:void(0)';
                        break;
                    case 'MANHOUR_MODIFY_FINISH':
                        type = '工时通知'
                        if (fp.contains(item.roleCode, ['BO', 'PM', 'PML', 'CRCM', 'CRCC', 'CRC', 'PA'])) {
                            path = item.relateId ? `/#/manHour/confirm/${(item.queryConditions) && (item.queryConditions).slice(9)}/${item.relateId}` : 'javascript:void(0)';
                            setCenter(setSession, item);
                        } else {
                            path = 'javascript:void(0)';
                        }
                        break;
                    case 'MANHOUR_MODIFY':
                        type = '工时通知'
                        if (fp.contains(item.roleCode, ['BO', 'PM', 'PML', 'CRCM', 'CRCC', 'CRC', 'PA'])) {
                            if (item.noticeInfo.includes('有实际访视数，但无工时数，请及时录入工时')) {
                                path = `/#/execute/manHour/${item.relateId}`;
                            } else {
                                path = item.relateId ? `/#/manHour/myHour/${(item.queryConditions) && (item.queryConditions).slice(9)}/${item.relateId}` : 'javascript:void(0)';
                            }
                            setCenter(setSession, item);
                        } else {
                            path = 'javascript:void(0)';
                        }
                        break;
                    case 'MANHOUR_MODIFY_RECEIVE':
                        type = '工时修改确认提醒'
                        if (fp.contains(item.roleCode, ['BO', 'PM', 'PML', 'CRCM', 'CRCC', 'CRC', 'PA'])) {
                            path = item.relateId ? `/#/manHour/confirm/${(item.queryConditions) && (item.queryConditions).slice(9)}/${item.relateId}` : 'javascript:void(0)';
                            setCenter(setSession, item);
                        } else {
                            path = 'javascript:void(0)';
                        }
                        break;
                    case "MANHOURVERIFY":
                        type = '工时确认提醒';
                        path = item.relateId ? `/#/execute/manHour/${item.relateId}` : 'javascript:void(0)';
                        setProject(setSession, item, true);
                        break;
                    case 'JDEEXAMINE':
                        type = 'JDE主项目号审批通知';
                        path = "JDEEXAMINEMODAL";
                        setSession.noticeId = item.noticeId;
                        break;
                    case "JDEEXAMINE_PA":
                        type = 'JDE主项目号审批通知';
                        path = '/#/projectContract/mainContract';
                        setProject(setSession, item);
                        break;
                    case 'JDE_REPEAT':
                        type = 'JDE项目号复用通知';
                        path = 'javascript:void(0)';
                        break;
                    case 'FTE_OVER_LIMIT':
                        type = '项目完工Total值超限提醒'
                        path = `/#/sumTotal/percent`;
                        setSession.curRole = item.roleCode;
                        setProject(setSession, item, true);
                        break;
                    case 'HEREDITY_REPEAT':
                        type = '遗传办提醒';
                        path = `/#/startUp/heredity`;
                        setSession.curRole = item.roleCode;
                        setProject(setSession, item, true);
                        break;
                    case 'RECIPIENT_FILL_IN_MAN_HOUR':
                        type = '交接未完成提醒';
                        if (item.queryConditions) {
                            path = `/#/execute/transfer/code_${item.queryConditions && item.queryConditions.slice(13)}`;
                            setSession.curRole = item.roleCode;
                            setProject(setSession, item, true);
                        } else {
                            path = `javascript:void(0)`;
                        }
                        break;
                    case 'INVESTIGATION_STAGE_REMIND':
                        type = '项目阶段更新提醒';
                        path = `/#/invDetails`;
                        setSession.curRole = item.roleCode;
                        setProject(setSession, item);
                        break;
                    // case 'INVESTIGATION_TERMINATION':
                    //     type = '终止协议审核通知';
                    //     path = `/#/endAgreement`;
                    //     setSession.curRole = item.roleCode;
                    //     setProject(setSession, item, true);
                    //     break;
                    case 'INVESTIGATION_THRESHOLD':
                        type = '项目完工Total阀值调整通知';
                        path = `/#/sumTotal/percent`;
                        setSession.curRole = item.roleCode;
                        setProject(setSession, item, true);
                        break;
                    case 'INVESTIGATION_THRESHOLD_APPLY':
                        type = '项目完工Total阀值超限申请';
                        path = `/#/sumTotal/percent`;
                        setSession.curRole = item.roleCode;
                        setProject(setSession, item, true);
                        break;
                    case 'SUPPLEMENTARY_AGREEMENT':
                        type = '补充协议提醒';
                        path = `/#/sumTotal/percent`;
                        setSession.curRole = item.roleCode;
                        setProject(setSession, item, true);
                        break;
                    case 'JDE_APPLY':
                        type = 'JDE建号申请通知';
                        params.jdeApplyCode = item.jdeApplyCode;
                        if (item.roleCode == 'PM') {
                            path = `/#/projectContract/applyJdeCode`;
                            setSession.curRole = item.roleCode;
                            setProject(setSession, item, true);
                        }else if(item.roleCode == 'FIN'){
                            path = `/#/contractManagement/applyJdeCode/${item.jdeApplyCode}`;
                            if (item.roleCode) {
                                setSession.curRole = item.roleCode;
                            }
                            clearCenter(setSession);
                        }else {
                            path = `/#/contractManagement/applyJdeCode`;
                            if (item.roleCode  && item.roleCode !== 'TAL') {
                                setSession.curRole = item.roleCode;
                            }
                            clearCenter(setSession);
                        }
                        break;
                    case 'JDE_APPLY_AUTO_MAIN_CODE':
                        type = 'JDE主项目号自动设置通知';
                        path = `/#/projectContract/mainContract`;
                        params.jdeApplyCode = item.jdeApplyCode;
                        setSession.curRole = item.roleCode;
                        setProject(setSession, item, true);
                        break;
                    case 'PLAN_FTE_ADJUSTMENT':
                        type = '预计工时调整提醒';
                        path = 'PLAN_FTE_ADJUSTMENT'
                        params.planFteAdjustmentById = item.relateId;
                        setSession.noticeId = item.noticeId;
                        setSession.curRole = item.roleCode;
                        setProject(setSession, item, true);
                        break;
                    case 'JDE_MAIN_APPLY':
                        type = 'JDE主项目号变更申请通知';
                        params.jdeMainApplyCode = item.jdeMainApplyCode;
                        if (item.roleCode == 'PM') {
                            path = `/#/projectContract/alterJdeCode`;
                            setSession.curRole = item.roleCode;
                            setProject(setSession, item, true);
                        } else {
                            path = `/#/contractManagement/alterJdeCode`;
                            if (item.roleCode) {
                                setSession.curRole = item.roleCode;
                            }
                            clearCenter(setSession);
                        }
                        break;
                    case 'CASH_REQ':
                        type = '合同请款通知';
                        path = `/#/contractManagement/requestRecord`;
                        params = parseQueryConditions(item.queryConditions);
                        params.investigationName = item.investigationName;
                        params.investigationJdeContractCode = item.investigationJdeContractCode;
                        if (item.roleCode) {
                            setSession.curRole = item.roleCode;
                        }
                        clearCenter(setSession);
                        break;
                    case 'REMITTANCE_ADJUST_APPLY':
                        type = '合同请款调整申请通知';
                        path = `/#/contractManagement/requestRecord`;
                        params.remittanceCode = item.remittanceCode;
                        clearCenter(setSession);
                        break;
                    case 'INVESTIGATION_STOP':
                        type = '项目结束通知';
                        path = `INVESTIGATION_STOP`;
                        params.investigationName = item.investigationName;
                        clearCenter(setSession);
                        break;
                    case 'CRC_OUT_GROUP':
                        type = 'CRC出组通知';
                        path = 'javascript:void(0)'
                        break;
                    case 'INV_TERMINATION_APPLY':
                        type = '项目终止申请通知';
                        path = `/#/contractManagement/terminationApply`;
                        params.investigationId = item.investigationId;
                        params.investigationName = item.investigationName;
                        if (item.roleCode) {
                            setSession.curRole = item.roleCode;
                        }
                        clearCenter(setSession);
                        break;
                    case 'CONTRACT_COMPLETE_APPLY':
                        type = '合同确认请款完成通知';
                        path = `/#/contractManagement/contractRecord`;
                            params.path = '/contractManagement/contractRecord';
                            params.investigationName = item.investigationName;
                            params.investigationJdeCode = item.contractJdeContractCode;
                            if (item.roleCode) {
                                setSession.curRole = item.roleCode;
                            }
                            clearCenter(setSession);
                        break;
                    case "CONTRACT_COMPLETE_APPLY_TOW": {
                        type = "合同确认请款完成通知";
                        path = `/#/contractManagement/contractRecord`;
                        params = {
                            path: '/contractManagement/contractRecord',
                            investigationJdeCode: item.contractJdeContractCode,
                        };
                        const { positionRole } = sessionStorage;
                        setSession.curRole = positionRole;
                        clearCenter(setSession);
                        break;
                    }
                    case 'INV_COMPLETE_APPLY':
                        type = '项目确认请款完成通知';
                        {
                            path = `/#/contractManagement/contractRecord`;
                            params.path = '/contractManagement/contractRecord';
                            params.investigationName = item.investigationName;
                            if (item.roleCode) {
                                setSession.curRole = item.roleCode;
                            }
                            clearCenter(setSession);
                        }
                        break;
                    case 'USER_TEACHER_REMIND':
                        type = '新人带教老师登记通知';
                        path = 'USER_TEACHER_REMIND';
                        params = parseQueryConditions(item.queryConditions);
                        params.userId = item.relateId;
                        params.isDirectSupervisor = item.isDirectSupervisor;
                        break;
                    case 'CRC_EVALUATE_REMIND': {
                        type = '带教质量评估提醒';
                        path = 'javascript:void(0)';
                        const { positionRole } = sessionStorage;
                        if (item.roleCode === 'CRC' && positionRole === 'CRC') {
                            path = '/#/teaching/qualityAssessmentSheet';
                            clearCenter(setSession);
                        }
                        params = parseQueryConditions(item.queryConditions);
                        break;
                    }
                    case 'CRC_HAVE_EVALUATED_REMIND':
                        type = '带教质量评估提醒';
                        path = '/#/teaching/management';
                        params = parseQueryConditions(item.queryConditions);
                        clearCenter(setSession);
                        break;
                    case 'REMITTANCE_CUSTOMER_APPLY':
                        type = '客户付款单位调整申请';
                        path = `/#/contractManagement/requestRecord`;
                        params.remittanceCode = item.remittanceCode;
                        if (item.roleCode) {
                            setSession.curRole = item.roleCode;
                        }
                        clearCenter(setSession);
                        break;
                    case 'DISEASE_CHANGE':
                        type = '项目疾病调整通知';
                        path = `DISEASE_CHANGE`;
                        params.investigationName = item.investigationName;
                        clearCenter(setSession);
                        break;
                    case 'LINE_OF_BUSINESS_CHANGE':
                        type = '项目业务线变更通知';
                        path = `LINE_OF_BUSINESS_CHANGE`;
                        params.investigationName = item.investigationName;
                        clearCenter(setSession);
                        break;
                    case 'INVESTIGATION_INFO_COMPLETED':
                        type = '项目信息完善通知';
                        path = `INVESTIGATION_INFO_COMPLETED`;
                        params.investigationName = item.investigationName;
                        clearCenter(setSession);
                        break;
                    case "CONTRACT_MODIFY_NOTICE": {
                        type = "合同信息变更申请通知";
                        path = `CONTRACT_MODIFY_NOTICE`;
                        params = parseQueryConditions(item.queryConditions,true);
                        params.applyCode = item.applyCode;
                        params.applyCode = item.WebCondition;
                        if (item.roleCode === 'PM' && item.fieldType === 'contractType') {
                            setSession.curRole = 'PM';
                            setProject(setSession, item, true);
                        } else {
                            const { positionRole } = sessionStorage;
                            setSession.curRole = positionRole;
                            clearCenter(setSession);
                        }
                        break;
                    }
                    case "COMPETING_COMPANY":
                        type = "竞争公司中心启动通知";
                        path = `COMPETING_COMPANY`;
                        params = parseQueryConditions(item.queryConditions);
                        setSession.curRole = item.roleCode;
                        setProject(setSession, item, true);
                        break;
                    case "CASH_REQ_NODE_REACH":
                    case "MILESTONE_REACH_NOTICE":
                    case "MILESTONE_DATE_REACH_NOTICE":
                    case "CONTRACT_CASH_REQ":
                        if (item.noticeType === 'CASH_REQ_NODE_REACH') {
                            type = "请款节点到达通知";
                            path = `CASH_REQ_NODE_REACH`;
                            params = {
                                webCondition: item.webCondition,
                                remittanceCode: item.cashRemittanceCode,
                            };
                        } else if (item.noticeType === 'MILESTONE_REACH_NOTICE') {
                            type = "milestone到达日期登记通知";
                            path = `MILESTONE_REACH_NOTICE`;
                            params = {
                                webCondition: item.webCondition,
                                remittanceCode: item.cashRemittanceCode,
                            };
                        } else if (item.noticeType === 'MILESTONE_DATE_REACH_NOTICE') {
                            type = "milestone到达日期通知";
                            path = `MILESTONE_DATE_REACH_NOTICE`;
                            params = {
                                webCondition: item.webCondition,
                                remittanceCode: item.cashRemittanceCode,
                            };
                        } else {
                            type = "合同请款通知";
                            path = `CONTRACT_CASH_REQ`;
                            params = {
                                webCondition: item.webCondition,
                                remittanceCode: item.cashRemittanceCode,
                            };
                        }
                        if (item.roleCode === 'PM') {
                            setSession.curRole = 'PM';
                            setProject(setSession, item, true);
                        } else {
                            const { positionRole } = sessionStorage;
                            setSession.curRole = positionRole;
                            clearCenter(setSession);
                        }
                        break;
                    case "REMITTANCE_REGISTER": {
                        type = "合同请款记录登记通知";
                        path = `REMITTANCE_REGISTER`;
                        params = {
                            webCondition: item.webCondition,
                            investigationId: item.investigationId,
                            investigationName: item.investigationName,
                            investigationJdeContractId: item.relateId,
                            remittanceCode: item.cashRemittanceCode,
                            ...parseQueryConditions(item.queryConditions),
                        };
                        const { positionRole } = sessionStorage;
                        setSession.curRole = positionRole;
                        clearCenter(setSession);
                        break;
                    }
                    case "NOTICE_CANCEL":
                        type = "消息通知取消申请";
                        path = `NOTICE_CANCEL`;
                        params = {
                            relateId: item.relateId,
                            webCondition: item.webCondition,
                        };
                        break;
                    case "BA_CHANGE":
                        type = "BA负责人变更通知";
                        path = `BA_CHANGE`;
                        params = parseQueryConditions(item.queryConditions);
                        setSession.curRole = item.roleCode;
                        clearCenter(setSession);
                        break;
                    case 'Refunded_Invoice': {
                        type = '回款到期提醒';
                        path = `/#/contractManagement/requestRecord`;
                        const { positionRole } = sessionStorage;
                        params = parseQueryConditions(item.queryConditions);
                        setSession.curRole = positionRole;
                        clearCenter(setSession);
                        break;
                    }
                    case "BA_HAND_OVER_Receiver":
                    case "BA_HAND_OVER_Over":
                    case "BA_HAND_OVER_BAL":
                    case "BA_HAND_OVER_Over_1": {
                        type = 'BA交接通知';
                        path = item.noticeType;
                        params = {
                            relateId: item.relateId,
                            webCondition: item.webCondition,
                        };
                        break;
                    }
                    case "DEPARTMENT_POSITION_ADD": {
                        type = '组织结构新增通知';
                        path = 'javascript:void(0)'
                        break;
                    }
                    case "CONTRACT_RELATE_SITE": {
                        type = '中心关联合同通知';
                        path = `CONTRACT_RELATE_SITE`;
                        setSession.curRole = item.roleCode;
                        setProject(setSession, item);
                        params = {
                            readStatus: item.readStatus,
                            handlerStatus:item.handlerStatus,
                        };
                        break;
                    }
                    case "COMPLAINT_RISK_CONFIRM": {
                        type = '投诉风险等级确认';
                        path = `/#/qualityManagement/complaintRegistrationForm`;
                        params = parseQueryConditions(item.queryConditions);
                        break;
                    }
                    case "VITAE_APPROVAL": {
                        type = '个人简历审批通知';
                        path = `VITAE_APPROVAL`;
                        params = {
                            ...parseQueryConditions(item.queryConditions),
                            relateId:item.relateId
                        }
                        break;
                    }
                    case 'INV_PLAN_TIME_AUTO_SET':{
                        type = '项目时间自动赋值通知';
                        path = `/#/invDetails`;
                        setSession.curRole = item.roleCode;
                        setProject(setSession, item);
                        break;
                    }
                    case 'CONTRACT_SIGNED_INFO':{
                        type = '合同签署完成通知';
                        path = `/#/site/detail`;
                        setSession.curRole = item.roleCode;
                        setProject(setSession, item);
                        break;
                    }
                    case 'VISIT_APPROVAL':{
                        type = '访视周期计划发布确认';
                        path = 'VISIT_APPROVAL';
                        setSession.curRole = item.roleCode;
                        setProject(setSession, item);
                        // target=inInv
                        // target=outInv
                        params = {
                            path : (!item.handlerStatus && item.webCondition !== 'NOT_JUMP' && parseQueryConditions(item.queryConditions, null, 'sp_qucon').target
                            =='outInv') ? `/#/executeMgr/visitPeriodPlanHandle`: (!item.handlerStatus && item.webCondition !== 'NOT_JUMP' && parseQueryConditions(item.queryConditions, null, 'sp_qucon').target
                            =='inInv') ? `/#/executeMgr/visitPeriodPlan` : 'javascript:void(0)',
                            handlerStatus:item.handlerStatus,
                            investigationId: item.investigationId,
                            investigationName: item.investigationName,
                            target: parseQueryConditions(item.queryConditions, null, 'sp_qucon').target,
                            webCondition: item.webCondition
                        }
                        break;
                    }
                    case 'NATION_VERIFY_ADD':{
                        type = '国家核查通知';
                        path = 'NATION_VERIFY_ADD';
                        params = parseQueryConditions(item.queryConditions);
                        break;
                    }
                    case 'CO_PLAN_NOTICE': {
                        type = 'CO跟进和请款预计通知';
                        path = '/#/contractManagement/coFollowFunds';
                        params = parseQueryConditions(item.queryConditions);
                        break;
                    }
                    case 'CONTRACT_BACK_CONFIRM_NOTICE': {
                        type = '发票和回款记录确认通知';
                        path = '/#/projectContract/returnedMoney';
                        params = parseQueryConditions(item.queryConditions);
                        break;
                    }
                    case 'INVESTIGATION_FINISH_PERCENT_CONFIRM': {
                        type = '完工进度确认';
                        path = `INVESTIGATION_FINISH_PERCENT_CONFIRM`;
                        params = parseQueryConditions(item.queryConditions, null, '&');
                        break;
                    }
                    case 'SSU_HOSPITAL_INFO_CONFIRM': {
                        type = '办事流程确认提醒';
                        path = `SSU_HOSPITAL_INFO_CONFIRM`;
                        params = parseQueryConditions(item.queryConditions);
                        params.relateId = item.relateId;
                        break;
                    }
                    case 'EVALUATE_RECORD_MESSAGE': {
                        type = '临床评估通知';
                        params = parseQueryConditions(item.queryConditions);
                        path = params.target == 'OUT_INV_BUSINESS_QUOTATION' ?  `/#/businessOffer/businessOfferRecord` : `/#/clinicalEvaluation/clinicalEvaluationRecord`;
                        break;
                    }
                    case 'REMIND_AUTHORIZATION_DATE': {
                        type = '授权时间确认提醒';
                        path = `/#/member/crc`;
                        setSession.curRole = item.roleCode;
                        setCenter(setSession, item);
                        params = parseQueryConditions(item.queryConditions);
                        break;
                    }
                    case 'VACATION_RECORD_MESSAGE': {
                        type = '项目成员休假提醒';
                        path = "javascript:void(0)";
                        break;
                    }
                    case 'BUSINESS_QUOTATION_MESSAGE': {
                        type = '商务报价通知';
                        path = `/#/businessOffer/businessOfferRecord`;
                        params = parseQueryConditions(item.queryConditions);
                        break;
                    }
                    case 'COV_TIME_REGISTER': {
                        type = 'COV计划时间登记通知';
                        path = `/#/teaching/management`;
                        params = parseQueryConditions(item.queryConditions);
                        break;
                    }
                    case 'PERSONAL_FILE_UPLOAD': {
                        type = '个人文档上传通知';
                        if (params.target == 'OUT_INV_SELF_VITAE') {
                            path = `/#/personal/curriculumVitae`;
                        } else if (params.target == 'OUT_INV_EMP_VITAE_DETAIL') {
                            path = `/#/user/userResume`;
                        } else if (params.target == 'OUT_INV_EMP_FILE') {
                            path = `/#/personal/file`;
                        } else if (params.target == 'IN_INV_SITE_FILE_MANAGE') {
                            setCenter(setSession, params);
                            path = `/#/fileManagement/projectFile`;
                        } else {
                            path = 'javascript:void(0)';
                        }
                        params = parseQueryConditions(item.queryConditions);
                        break;
                    }
                    case 'PERSONAL_VITAE_APPROVE': {
                        type = '个人简历审批通知';
                        path = `/#/personal/file`;
                        params = parseQueryConditions(item.queryConditions);
                        break;
                    }
                    case 'INV_CLOSE_REMIND': {
                        type = '项目确认关闭通知';
                        path = `/#/contractManagement/contractRecord`;
                        params = parseQueryConditions(item.queryConditions);
                        params.path = '/contractManagement/contractRecord';
                        if (item.roleCode) {
                            setSession.curRole = item.roleCode;
                        }
                        clearCenter(setSession);
                        break;
                    }
                    case 'FINANCIAL_ADJUST': {
                        type = '财务数据调整通知';
                        path = `/#/contractManagement/contractRecord`;
                        params = parseQueryConditions(item.queryConditions);
                        params.path = '/contractManagement/contractRecord';
                        if (item.roleCode) {
                            setSession.curRole = item.roleCode;
                        }
                        clearCenter(setSession);
                        break;
                    }
                    case 'HOSPITAL_INSTITUTION_BASIC_INFO': {
                        type = '机构备案核查消息';
                        path = `/#/hospital/filingInfo`;
                        params = parseQueryConditions(item.queryConditions);
                        break;
                    }
                    case 'NOT_SPECIFIES_AMOUNT_ADJUST': {
                        type = '非明标合同额调整通知';
                        path = `/#/contractManagement/contractRecord`;
                        params = parseQueryConditions(item.queryConditions);
                        params.path = '/contractManagement/contractRecord';
                        if (item.roleCode) {
                            setSession.curRole = item.roleCode;
                        }
                        clearCenter(setSession);
                        break;
                    }
                    case 'MAJOR_EVENT_MESSAGE': {
                        type = '重大事件通知';
                        path = 'javascript:void(0)';
                        break;
                    }
                }
                if (item.readStatus == 'readed') {
                    list.push(<li key={index} className=''><a onClick={() => { this.clickNotice(path, setSession, item.noticeId, index, params) }} style={{ width: '90%', display: 'inline-block' }} ><span>○ </span>[{type}]{item.noticeInfo}</a><time style={{ color: '#ccc' }}>{moment(item.createTime).format('YYYY/MM/DD')}</time></li>)
                } else {
                    list.push(<li key={index} className='read'><a onClick={() => { this.clickNotice(path, setSession, item.noticeId, index, params) }} style={{ width: '90%', display: 'inline-block' }} ><span>● </span>[{type}]{item.noticeInfo}</a><time style={{ color: '#ccc' }}>{moment(item.createTime).format('YYYY/MM/DD')}</time></li>)
                }
            });
        }
        return list;
    }

    render() {
        const { pagination: { total, current, pageSize }, data, auditJdeParams, expectHourParams, loading, centerRelateParams } = this.state;
        const { params, saveSearchParams, panes, activeKey, handleTabClick } = this.props;
        return (
            <div className="full">
                <Spin spinning={loading}>
                    <div style={{ color: '#3D33A9' }}><index className='icon iconfont'>&#xe65b;</index>消息
                    <div style={{ textAlign: 'right', position: 'absolute', right: '0' }}>
                            <Popconfirm title="是否确认全部标记为已读？" onConfirm={() => this.operateAll('read')} okText="是" cancelText="否">
                                <a className='icon iconfont'>&#xe617;</a>
                            </Popconfirm>
                            <span className="ant-divider" />
                            <Popconfirm title="是否清空所有消息？" onConfirm={() => this.operateAll('delete')} okText="是" cancelText="否">
                                <a className='icon iconfont'>&#xe615;</a>
                            </Popconfirm>
                        </div>
                    </div>
                    <Filter search={this.search} saveSearchParams={saveSearchParams} searchParams={params} />
                    <div style={{ width: "80%", margin: "0 auto", marginBottom: "-17px" }}>
                        <Tabs type="card" activeKey={activeKey} onChange={handleTabClick}>
                            {panes.map(pane => <TabPane tab={pane.title} key={pane.key}>{pane.content}</TabPane>)}
                        </Tabs>
                    </div>
                    <div className="content-2">
                        <ul className='notice'>
                            {data.length > 0 ? this.getNoticList() : <li style={{textAlign: 'center'}}>暂无内容</li>}
                        </ul>
                        {
                            !!total && <div className='pages'><Pagination onChange={this.handlePages} current={current} pageSize={pageSize} total={total} /></div>
                        }
                    </div>
                    <AuditJDE auditJdeParams={auditJdeParams} hideAuditJDE={this.hideAuditJDE} />
                    <ExpectHour expectHourParams={expectHourParams} hideExpectHour={this.hideExpectHour} loadData={this.loadData} />
                    <ConterctRelateSite centerRelateParams={centerRelateParams} hideCenterctRelateSite={this.hideCenterctRelateSite} loadData={this.loadData} confirmNoticeReadByOne={this.confirmNoticeReadByOne}/>
                    <RegisterRequest ref={el => this.requestRef = el} autoRegisterRequest={this.autoRegisterRequest} loadData={this.loadData} />
                    <ApproveCancelApply ref={el => this.approveRef = el} loadData={this.loadData} />
                    <ApproveBaBatchTransfer ref={el => this.approveBaTransferRef = el} loadData={this.loadData} />
                    <BaBatchTransfer ref={el => this.baTransferRef = el} loadData={this.loadData} />
                </Spin>
            </div>
        );
    }
}

const mapSateToProps = (state) => ({
    searchParams: state.noticeState.searchParams || {},
});

const mapDispatchToProps = (dispatch) => {
    return {
        saveParams: (params) => dispatch(saveParams(params)),
        saveSearchParams: (params) => dispatch(saveSearchParams(params)),
        saveProjectParams: (params) => dispatch(saveProjectParams(params)),
        saveResumeParams: (params) => dispatch(saveResumeParams(params)),
    }
}

export default connect(mapSateToProps, mapDispatchToProps)(Notice);



// WEBPACK FOOTER //
// ./src/components/layout/notice/Notice.js